"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ko = require("knockout");
var validatedViewModel_1 = require("../viewModels/base/validatedViewModel");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var TargetType;
(function (TargetType) {
    TargetType[TargetType["User"] = 0] = "User";
    TargetType[TargetType["Work"] = 1] = "Work";
    TargetType[TargetType["Post"] = 2] = "Post";
    TargetType[TargetType["Review"] = 3] = "Review";
    TargetType[TargetType["Comment"] = 4] = "Comment";
    TargetType[TargetType["Collection"] = 5] = "Collection";
    TargetType[TargetType["Art"] = 6] = "Art";
})(TargetType || (TargetType = {}));
var FeedbackFormComponent = (function (_super) {
    __extends(FeedbackFormComponent, _super);
    function FeedbackFormComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params);
        this.commentMaxLength = 1000;
        this.targetId = ko.observable();
        this.targetType = ko.observable();
        this.targetTypeAsString = ko.pureComputed(function () {
            return TargetType[_this.targetType()];
        });
        this.url = ko.observable();
        this.title = ko.pureComputed(function () {
            var title = "Жалоба на ";
            switch (_this.targetType()) {
                case TargetType.User:
                    title += "пользователя";
                    break;
                case TargetType.Work:
                    title += "произведение";
                    break;
                case TargetType.Post:
                    title += "запись в блоге";
                    break;
                case TargetType.Review:
                    title += "рецензию";
                    break;
                case TargetType.Comment:
                    title += "комментарий";
                    break;
                case TargetType.Collection:
                    title += "подборку";
                    break;
            }
            return title;
        });
        this.comment = ko.observable("");
        this.commentHint = ko.pureComputed(function () {
            var comment = _this.comment() || "";
            return comment.length + "/" + _this.commentMaxLength;
        });
        this.categories = ko.pureComputed(function () {
            var result = [];
            switch (_this.targetType()) {
                case TargetType.User:
                    result = [
                        "Нарушение правил",
                        "Оскорбление",
                        "Спам",
                        "Остальное"
                    ];
                    break;
                case TargetType.Comment:
                    result = [
                        "Нарушение правил",
                        "Оскорбление",
                        "Провокация конфликта",
                        "Спам",
                        "Остальное"
                    ];
                    break;
                case TargetType.Post:
                    result = [
                        "Нарушение правил",
                        "Неправильная тема",
                        "Спам",
                        "Остальное"
                    ];
                    break;
                case TargetType.Review:
                case TargetType.Collection:
                    result = [
                        "Нарушение правил",
                        "Неправильные тэги",
                        "Спам",
                        "Остальное"
                    ];
                    break;
                case TargetType.Work:
                    result = [
                        "Неправильный жанр (укажите какой именно)",
                        "Книга продается по подписке и давно не обновлялась автором",
                        'Произведение не соответствует статусу ("полный текст", "в процессе", "ознакомительный фрагмент")',
                        "Нарушение авторского права",
                        "Материал для взрослых (18+)",
                        "Нарушение правил сайта",
                        "Спам",
                        "Книга создана с помощью нейросети",
                        "Остальное"
                    ];
                    break;
                case TargetType.Art:
                    result = [
                        "Нарушение авторского права",
                        "Материал для взрослых (18+)",
                        "Нарушение правил сайта",
                        "Спам",
                        "Остальное"
                    ];
                    break;
            }
            return result;
        });
        this.selectedCategory = ko.observable().extend({
            required: {
                value: true,
                message: "Пожалуйста, укажите причину жалобы"
            }
        });
        this.params = params;
        this.element = element;
        this.templateNodes = templateNodes;
    }
    FeedbackFormComponent.prototype.show = function (targetId, targetType, url) {
        var _this = this;
        this.errorMessages([]);
        this.targetId(targetId);
        this.targetType(TargetType[targetType]);
        this.url(url);
        if (this.comment()) {
            this.comment(null);
        }
        if (this.selectedCategory()) {
            this.selectedCategory(null);
        }
        setTimeout(function () {
            if (_this.validation === undefined) {
                _this.initValidation();
            }
        }, 0);
        if (!app.ensureAuth("Только зарегистрированные пользователи могут оставлять жалобы.")) {
            return;
        }
        app.closeModal();
        app.f7.pickerModal(document.getElementById("mobileFeedbackForm"));
        app.showOverlayModal();
    };
    FeedbackFormComponent.prototype.submit = function () {
        var _this = this;
        if (this.validation !== undefined && !this.validation.isValid()) {
            this.validation.errors.showAllMessages();
            return;
        }
        ;
        if (this.processing())
            return;
        this.processing(true);
        this.errorMessages([]);
        var data = {
            targetId: this.targetId(),
            targetType: this.targetTypeAsString(),
            url: this.url(),
            category: this.selectedCategory(),
            comment: this.comment()
        };
        ajaxUtils_1.AjaxUtils.post("feedback/complaint", data)
            .done(function (result) {
            if (result.isSuccessful) {
                app.f7.closeModal(document.getElementById("mobileFeedbackForm"));
                app.f7.alert("Спасибо за то, что помогаете делать наш сервис еще лучше!", "Жалоба отправлена");
            }
            else {
                _this.errorMessages(result.messages);
            }
        }).always(function () {
            _this.processing(false);
        });
    };
    return FeedbackFormComponent;
}(validatedViewModel_1.default));
ko.components.register("mobile-feedback-form", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FeedbackFormComponent;
//# sourceMappingURL=mobileFeedbackForm.js.map